import { createContext, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { useContextWithCheck } from 'hooks'
import { WithChild } from 'utils'

import { languages, defaultLanguage } from './I18n.config'

import { I18nContextData } from './index'

const I18nContext = createContext<I18nContextData | undefined>(undefined)

export const I18nProvider = ({ children }: WithChild) => {
  const { i18n } = useTranslation()

  const changeLanguage = useCallback(
    (lang: string) => {
      moment.locale(lang)
      return i18n.changeLanguage(lang)
    },
    [i18n],
  )

  useEffect(() => {
    moment.locale(i18n.language)
  }, [i18n.language])

  // useEffect(() => {
  //   i18nInitialize('main').then()
  // }, [])

  return (
    <I18nContext.Provider
      value={{
        i18n,
        language: i18n.language,
        languages,
        defaultLanguage,
        changeLanguage,
      }}
    >
      {children}
    </I18nContext.Provider>
  )
}

export const useI18n = () => useContextWithCheck(I18nContext)
